import {initializeApp} from "firebase/app";
import {Route, Routes} from "react-router-dom";
import Home from "./containers/home";
import firebaseConfig from './firebase-config'
import SelfStudy from "./containers/self-study";
import JobsInternship from "./containers/job-internship";

function App() {
    // Initialize Firebase
    initializeApp(firebaseConfig);
    return (
        <Routes>
            <Route path="/" element={<Home/>}/>
            <Route path="/self_study" element={<SelfStudy/>}/>
            <Route path="/jobs_internship" element={<JobsInternship/>}/>
        </Routes>
    );
}

export default App;
